'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var changeFieldId = function changeFieldId(schema, parentFieldId) {
  if (!(0, _lodash.isEmpty)(schema.children) && 'Card' !== schema.componentName) {
    schema.children.forEach(function (item) {
      item.props.fieldId = parentFieldId + '>' + item.props.fieldId;
      changeFieldId(item);
    });
  }
};

var SplitJoint = (_temp = _class = function (_Field) {
  _inherits(SplitJoint, _Field);

  function SplitJoint(props) {
    _classCallCheck(this, SplitJoint);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    if (props.$state) {
      props.$state.originalInvokeValidate = props.$state.invokeValidate;
      props.$state.invokeValidate = _this.invokeValidate.bind(props.$state, _this);
    }
    return _this;
  }

  SplitJoint.prototype.fieldDataFormatter = function fieldDataFormatter() {
    // 格式化获取父组件的值
    var $state = this.props.$state;

    var result = {};
    (0, _lodash.forEach)($state.subStates, function (field, key) {
      var componentName = field.getData('componentName');
      if (['Label', 'LineBreak', 'Button'].includes(componentName)) {
        return true;
      }
      result[key] = field.getVal();
    });
    return result;
  };

  SplitJoint.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var $state = nextProps.$state;
    var $prevState = this.props.$state;

    var nextStateJS = $state && $state.toJS();
    var prevStateJS = $prevState && $prevState.toJS();
    if (!(0, _lodash.isEqual)(nextStateJS, prevStateJS)) {
      return true;
    }

    // 增加表单选择模式状态更新判断
    if (nextProps.context && !nextProps.disableFieldSelect) {
      var fieldsSelectModeStatus = nextProps.context.getGlobal('fieldsSelectModeStatus') || false;
      var fieldsSelectModeData = nextProps.context.getGlobal('fieldsSelectModeData') || [];
      var checked = fieldsSelectModeData.findIndex(function (i) {
        return i && i.fieldId === nextProps.fieldId;
      }) >= 0;

      // 判断是否更新
      var currentParentState = _Field.prototype.getComponentState.call(this);
      if (currentParentState.fieldSelectedStatus !== fieldsSelectModeStatus || currentParentState.fieldSelectedChecked !== checked) {
        return true;
      }
    }

    return false;
  };

  SplitJoint.prototype.componentDidMount = function componentDidMount() {
    _Field.prototype.componentDidMount.call(this);
    this.onComponentReady(true);
  };

  SplitJoint.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    typeof _Field.prototype.componentDidUpdate === 'function' && _Field.prototype.componentDidUpdate.call(this, prevProps, prevState);
    var fieldData = this.props.fieldData;

    var fieldDataChanged = JSON.stringify(prevProps.fieldData) !== JSON.stringify(fieldData);
    this.onComponentReady(fieldDataChanged);
  };

  SplitJoint.prototype.onComponentReady = function onComponentReady(fieldDataChanged) {
    var _props = this.props,
        fieldId = _props.fieldId,
        initialSchema = _props.initialSchema,
        onRebindEvents = _props.onRebindEvents,
        $state = _props.$state;

    var subStates = {};
    var value = fieldDataChanged || !$state ? this.getValue() : this.fieldDataFormatter();
    if (initialSchema && !(0, _lodash.isEmpty)(initialSchema.children) && $state) {
      initialSchema.children.forEach(function (item) {
        var itemProps = item && item.props || {};
        var state = $state.getRoot().get(fieldId + '>' + itemProps.fieldId);
        state.disableValid();
        state.set('disableCollect', true);
        subStates[itemProps.fieldId] = state;

        if (value) {
          state.setVal(value[itemProps.fieldId]);
        }
        var prevVal = state.getVal();
        state.onChange((0, _lodash.debounce)(function () {
          var currentVal = state.getVal();
          if (prevVal !== currentVal) {
            prevVal = currentVal;
            $state.validation.valid(null);
          }
        }, 200));
        state.enableValid();
      });
      $state.subStates = subStates;
    }
    onRebindEvents && onRebindEvents();
  };

  SplitJoint.prototype.invokeValidate = function invokeValidate(context, pass, errorMsg) {
    var extraData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    if (arguments.length <= 1) {
      return this.forceValid();
    }
    var subId = extraData.subId;

    var _ref = context.props || {},
        $state = _ref.$state;

    if ((0, _lodash.isNil)(subId)) {
      // 为空，触发父组件的校验
      $state && $state.originalInvokeValidate(pass, errorMsg);
      // 同时触发所有子组件的校验
    } else {
      var fieldState = $state.subStates && $state.subStates[subId];
      fieldState && fieldState.invokeValidate(pass, errorMsg);
    }
  };

  SplitJoint.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-assembly'
    });
  };

  // 覆写父类中的选中field后的value值


  SplitJoint.prototype.getSelectFieldFormatValue = function getSelectFieldFormatValue() {
    return '--';
  };

  SplitJoint.prototype.renderChildren = function renderChildren() {
    var _this2 = this;

    var isDetail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _props2 = this.props,
        fieldId = _props2.fieldId,
        children = _props2.children;

    if ((0, _lodash.isEmpty)(children)) {
      return null;
    }
    return children.map(function (child) {
      var componentSchema = JSON.parse(JSON.stringify(child.props.componentSchema));
      componentSchema.props.fieldId = fieldId + '>' + componentSchema.props.fieldId;
      changeFieldId(componentSchema, fieldId);

      componentSchema.props.showLabel = false;
      if (isDetail) {
        componentSchema.props.readonly = true;
      }

      return _react2.default.cloneElement(child, _extends({}, child.props, {
        // 将表单选择模式change方法注入到child组件中，用于child组件进行调用
        onFieldsSelectChange: _this2.props.onFieldsSelectChange || function () {},
        componentSchema: componentSchema,
        isChildComponent: true,
        disableFieldSelect: true // 拼接组件禁用子组件的表单项选择模式，服务端不支持
      }));
    });
  };

  SplitJoint.prototype.renderControl = function renderControl() {
    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      this.renderChildren()
    );
  };

  SplitJoint.prototype.renderView = function renderView() {
    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      this.renderChildren(true)
    );
  };

  return SplitJoint;
}(_vuFusionField2.default), _class.displayName = 'SplitJoint', _class.validators = {
  defaultValueFormatter: function defaultValueFormatter(state) {
    return (0, _lodash.pickBy)(state.fieldDataFormatter(), function (value) {
      return !(0, _lodash.isNil)(value);
    });
  },
  required: {
    valid: function valid(value, param) {
      return !(0, _lodash.isEmpty)(value);
    },
    defaultMessage: {
      en_US: '%s cannot be empty',
      zh_CN: '%s不能为空'
    }
  },
  extraValidation: function extraValidation(state, force) {
    if (!force) {
      return;
    }
    var subStates = state.subStates;
    var errorMsg = null;
    var hasError = false;
    (0, _lodash.forEach)(subStates, function (field, key) {
      if (field && field.isState) {
        if (!field.getValue('hasError')) {
          field.forceValid();
        }
        if (field.getValue('hasError') && !hasError) {
          hasError = true;
          return true;
        }
      }
    });
    if (hasError) {
      errorMsg = '组件内部字段校验失败';
    }
    return { errorMsg: errorMsg, hasError: hasError };
  }
}, _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  fieldId: null,
  label: null
}), _class.propTypes = _extends({}, _vuFusionField2.default.propsTypes, {
  fieldId: _propTypes2.default.string,
  label: _propTypes2.default.string
}), _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), [{
  name: 'fieldData',
  formatIn: function formatIn(fieldData, data) {
    var fieldDataValue = fieldData && fieldData.value || {};
    return _extends({}, fieldData, { value: fieldDataValue });
  },
  formatOut: function formatOut(fieldData, data) {
    return fieldData;
  }
}]), _temp);
exports.default = SplitJoint;
module.exports = exports['default'];